// extracted by css-extract-rspack-plugin
export default {"containerHorizontal":"containerHorizontal-SZyRys","containerVertical":"containerVertical-yXjET8"};